<template>
  <div class="container-fluid">
    <Breadcrumbs title="Cambiar Contraseña" main="Configuración" />
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4">
            <h4 class="fw-bold mb-2">Cambiar Contraseña</h4>
            <p class="text-muted mb-4">Actualiza tu contraseña de acceso al sistema.</p>

            <form @submit.prevent="actualizarContrasena" class="row g-3">
              <div class="col-12">
                <label class="form-label fw-semibold">Contraseña Actual <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    v-model="form.actual"
                    :type="verActual ? 'text' : 'password'"
                    class="form-control"
                    :class="{ 'is-invalid': errores.actual }"
                    placeholder="Ingrese su contraseña actual"
                  />
                  <button type="button" class="btn btn-outline-secondary" @click="verActual = !verActual">
                    <vue-feather :type="verActual ? 'eye-off' : 'eye'" size="18" />
                  </button>
                  <div v-if="errores.actual" class="invalid-feedback d-block">{{ errores.actual }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label fw-semibold">Nueva Contraseña <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    v-model="form.nueva"
                    :type="verNueva ? 'text' : 'password'"
                    class="form-control"
                    :class="{ 'is-invalid': errores.nueva }"
                    placeholder="Mínimo 6 caracteres"
                  />
                  <button type="button" class="btn btn-outline-secondary" @click="verNueva = !verNueva">
                    <vue-feather :type="verNueva ? 'eye-off' : 'eye'" size="18" />
                  </button>
                </div>
                <div v-if="errores.nueva" class="invalid-feedback d-block">{{ errores.nueva }}</div>
                <div class="form-text">La contraseña debe tener al menos 6 caracteres.</div>
              </div>

              <div class="col-md-6">
                <label class="form-label fw-semibold">Confirmar Nueva Contraseña <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    v-model="form.confirmar"
                    :type="verConfirmar ? 'text' : 'password'"
                    class="form-control"
                    :class="{ 'is-invalid': errores.confirmar }"
                    placeholder="Repita la nueva contraseña"
                  />
                  <button type="button" class="btn btn-outline-secondary" @click="verConfirmar = !verConfirmar">
                    <vue-feather :type="verConfirmar ? 'eye-off' : 'eye'" size="18" />
                  </button>
                  <div v-if="errores.confirmar" class="invalid-feedback d-block">{{ errores.confirmar }}</div>
                </div>
              </div>

              <div class="col-12 d-flex gap-2 mt-4">
                <button type="submit" class="btn btn-primary" :disabled="enviando">
                  <span v-if="enviando" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  Actualizar Contraseña
                </button>
                <button type="button" class="btn btn-warning text-dark" @click="regresar">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "CambiarContrasena",
  data() {
    return {
      form: { actual: "", nueva: "", confirmar: "" },
      errores: { actual: "", nueva: "", confirmar: "" },
      verActual: false,
      verNueva: false,
      verConfirmar: false,
      enviando: false,
    };
  },
  methods: {
    validar() {
      this.errores = { actual: "", nueva: "", confirmar: "" };
      let ok = true;
      if (!this.form.actual.trim()) {
        this.errores.actual = "Ingrese su contraseña actual.";
        ok = false;
      }
      if (this.form.nueva.length < 6) {
        this.errores.nueva = "La contraseña debe tener al menos 6 caracteres.";
        ok = false;
      }
      if (this.form.nueva !== this.form.confirmar) {
        this.errores.confirmar = "Las contraseñas no coinciden.";
        ok = false;
      }
      return ok;
    },
    async actualizarContrasena() {
      if (!this.validar()) return;
      this.enviando = true;
      try {
        await this.$store.dispatch("autenticacion/cambiarContrasena", {
          actual: this.form.actual,
          nueva: this.form.nueva,
        });

        Swal.fire({
          icon: "success",
          title: "Contraseña actualizada",
          text: "Tu contraseña se ha cambiado correctamente.",
        });
        this.form = { actual: "", nueva: "", confirmar: "" };
        this.regresar();
      } catch (e) {
        Swal.fire({ icon: "error", title: "Error", text: e.msg || "No se pudo actualizar la contraseña." });
      } finally {
        this.enviando = false;
      }
    },
    regresar() {
      if (window.history.state?.back) {
        this.$router.back();
      } else {
        this.$router.push("/dashboard/mi-perfil");
      }
    },
  },
};
</script>
